"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.occupationConfig = exports.militaryNumber = exports.military = exports.jobTitle = exports.OccupationDefinition = void 0;

var _types = require("../../types");

var _fieldDefinitionTypes = require("../../fields/config/fieldDefinitionTypes");

var _config = require("../config");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var ComponentConfigDefinition = _flowRuntime["default"].tdz(function () {
  return _config.ComponentConfigDefinition;
});

var CheckboxDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldDefinitionTypes.CheckboxDefinition;
});

var TextfieldDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldDefinitionTypes.TextfieldDefinition;
});

var ComponentElementDefinition = _flowRuntime["default"].tdz(function () {
  return _types.ComponentElementDefinition;
});

var military = {
  key: 'military',
  normalize: 'boolean',
  type: 'checkbox',
  items: [{
    key: 'militaryCheckbox',
    label: 'This job is in the military'
  }],
  ui: {
    classes: 'small',
    descriptionPosition: 'before'
  },
  validation: []
};
exports.military = military;
var militaryNumber = {
  key: 'militaryNumber',
  type: 'text',
  label: 'Military personnel service number',
  validation: []
};
exports.militaryNumber = militaryNumber;
var jobTitle = {
  key: 'jobTitle',
  label: 'Job Title',
  type: 'text',
  validation: []
}; // eslint-disable-next-line import/prefer-default-export

exports.jobTitle = jobTitle;
var occupationConfig = {
  type: 'occupation',
  fields: [military, militaryNumber, jobTitle]
};
exports.occupationConfig = occupationConfig;

var OccupationDefinition = _flowRuntime["default"].type("OccupationDefinition", _flowRuntime["default"].spread(_flowRuntime["default"].ref(ComponentElementDefinition), _flowRuntime["default"].object(_flowRuntime["default"].property("type", _flowRuntime["default"].string("occupation")), _flowRuntime["default"].property("options", _flowRuntime["default"].object(_flowRuntime["default"].property("military", _flowRuntime["default"]["boolean"]()))))));

exports.OccupationDefinition = OccupationDefinition;